(function () {
  const nodes = document.querySelectorAll('[data-fake-inventory]');
  if (!nodes.length) return;

  const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  nodes.forEach((node) => {
    const handle = node.dataset.productHandle || 'global';
    const start = parseInt(node.dataset.start, 10);
    const min = parseInt(node.dataset.min, 10);
    const decMin = parseInt(node.dataset.decMin, 10);
    const decMax = parseInt(node.dataset.decMax, 10);
    const intMin = parseInt(node.dataset.intMin, 10) * 1000;
    const intMax = parseInt(node.dataset.intMax, 10) * 1000;
    const threshold = parseInt(node.dataset.threshold, 10);
    const barMax = parseInt(node.dataset.barMax, 10) || start;
    const normalRgb = node.dataset.normalRgb;
    const lowRgb = node.dataset.lowRgb;

    const storageKey = `fakeInv:${handle}:${start}`;
    const textEl = node.querySelector('[data-fake-text]');
    const pillOuter = node.querySelector('[data-fake-pill-outer]');
    const pillInner = node.querySelector('[data-fake-pill-inner]');
    const bar = document.querySelector(`[data-fake-for="${node.id}"]`);
    const barInner = bar ? bar.querySelector('[data-fake-bar-inner]') : null;

    let current = parseInt(localStorage.getItem(storageKey), 10);
    if (isNaN(current) || current < min || current > start) current = start;

    const tpl = textEl ? textEl.innerHTML : '';
    const originalTpl = tpl.replace(new RegExp('\\b' + start + '\\b'), '[qty]');

    const render = () => {
      const isLow = current <= threshold;
      if (textEl) textEl.innerHTML = originalTpl.replace('[qty]', current);
      if (barInner) barInner.style.width = Math.min(100, Math.max(5, (current / barMax) * 100)) + '%';
      if (bar) bar.classList.toggle('is-low', isLow);
      const rgb = isLow ? lowRgb : normalRgb;
      if (pillOuter) pillOuter.setAttribute('fill', `rgba(${rgb},0.3)`);
      if (pillInner) pillInner.setAttribute('fill', `rgb(${rgb})`);
    };

    render();

    const tick = () => {
      if (current <= min) return;
      current = Math.max(min, current - rand(decMin, decMax));
      localStorage.setItem(storageKey, current);
      render();
      setTimeout(tick, rand(intMin, intMax));
    };
    setTimeout(tick, rand(intMin, intMax));
  });
})();